module.exports = __webpack_public_path__ + "static/media/announce.944c9a04.svg";